import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  Filter,
  SearchInput,
  Show,
  SimpleShowLayout,
  SelectInput,
  DateField
} from 'react-admin'

import rowStyle from './rowStyle'

export const emailTypes = [
  'resetPassword',
  'verification'
]

export const emailStatusTypes = [
  'pending',
  'sent',
  'rejected',
  'error',
  'canceled'
]

export const EmailFilter = (props) => (
  <Filter {...props}>
    <SearchInput label='Search to' source='to' />
    <SearchInput label='Search subject' source='subject' />
    <SearchInput label='Search text' source='text' />
    <SelectInput source='type' choices={emailTypes.map(type => ({
      id: type,
      name: type
    }))} />
    <SelectInput source='status' choices={emailStatusTypes.map(type => ({
      id: type,
      name: type
    }))} />
  </Filter>
)

export const EmailShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source='id' />
      <TextField source='from.name' />
      <TextField source='from.address' />
      <TextField source='to' />
      <TextField source='subject' />
      <TextField source='html' />
      <TextField source='text' />
      <TextField source='type' />
      <TextField source='status' />
      <TextField source='error' />
      <DateField source='createdAt' showTime />
      <DateField source='updatedAt' showTime />
    </SimpleShowLayout>
  </Show>
)

export const EmailList = (props) => (
  <List {...props} filters={<EmailFilter />}>
    <Datagrid
      rowStyle={rowStyle}
      rowClick='show'
    >
      <TextField source='from.name' />
      <TextField source='to' />
      <TextField source='subject' />
      <TextField source='type' />
      <TextField source='status' />
      <DateField source='createdAt' />
      <DateField source='updatedAt' />
    </Datagrid>
  </List>
)
